import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ModulesCtx = createContext(null);

export function ModulesProvider({ children }) {
  const [modules, setModules] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/modules`);
      setModules(Array.isArray(data) ? data : []);
    } catch (err) {
      setModules([]);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Auto-refresh every 60s so admin changes propagate to live users
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh]);

  const getModule = useCallback(
    (name) => modules.find((m) => m.name === name),
    [modules]
  );

  const value = useMemo(
    () => ({ modules, loaded, refresh, getModule }),
    [modules, loaded, refresh, getModule]
  );

  return <ModulesCtx.Provider value={value}>{children}</ModulesCtx.Provider>;
}

export const useModules = () => {
  const ctx = useContext(ModulesCtx);
  if (!ctx) throw new Error("useModules must be used inside ModulesProvider");
  return ctx;
};
